
<div class="admin">
  <div class="admin-container2"
    v-if="getUser.user != null && (getUser.user.role === 'SuperAdmin' || getUser.user.role === 'Admin')">
    <!-- admin content -->
    <el-row class="admin-pannel">
      <el-col :span="12" :offset="6">
        <el-col :span="11">
          <el-button @click="showAdminContent('SignUp')">Create new user</el-button>
        </el-col>
        <el-col :span="2"> - </el-col>
        <el-col :span="11">
          <el-button @click="logout">Logout</el-button>
        </el-col>
      </el-col>
    </el-row>
    <el-row class="admin-pannel">
      <el-col :span="12" :offset="6">
        <el-col :span="11">
          <el-button @click="showAdminContent('StatsPerm')">Stats Restos</el-button>
        </el-col>
        <el-col :span="2"> - </el-col>
        <el-col :span="11">
          <el-button @click="getRestosInfos()">Admin Restos</el-button>
        </el-col>
      </el-col>
    </el-row>
    <el-row class="admin-pannel">
      <el-col :span="12" :offset="6">
        <el-col :span="11">
          <el-button @click="getGoogleRestosInfos()">Google Reservit</el-button>
        </el-col>
        <el-col :span="2"> - </el-col>
        <el-col :span="11">
          <el-button @click="showAdminContent('Stripe')">Stripe</el-button>
        </el-col>
      </el-col>
    </el-row>
    <el-row class="admin-pannel">
      <el-col :span="12" :offset="6">
        <el-col :span="11">
          <el-button @click="getAppInfos()">AppInfos</el-button>
        </el-col>
      </el-col>
    </el-row>

    <!-- SuperAdmin content -->
    <el-row class="admin-pannel" v-if="superAdmin">
      <el-col :span="12" :offset="6">
        <el-col :span="11">
          <el-button @click="changeMailLogin">Action</el-button>
        </el-col>
        <el-col :span="2"> - </el-col>
        <el-col :span="11">
          <el-button @click="showAdminContent('Auth')">Auth debug</el-button>
        </el-col>
      </el-col>
    </el-row>

    <!-- Admin Restos -->
    <el-row class="logapp" v-if="this.panelShow === 'AdminResto'">
      <el-col :span="20" :offset="2" class="logapp-container2">
        <el-row class="admin-resto-content">
          <div class="admin-resto-title">Administration des restaurants</div>
          <el-col>
            <el-row style="padding:10px">
              <el-col :span="12">
                <el-input v-model="searchResto" placeholder="Rechercher par nom restaurant">
                  <i class="el-icon-search el-input__icon" slot="prefix"></i>
                </el-input>
              </el-col>
              <el-col :offset="1" :span="11">
                <el-select v-model="typeResto" placeholder="Type de restaurant">
                  <el-option v-for="item in optionsType" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
          </el-col>

          <!-- header -->
          <el-col class="admin-resto-line admin-resto-line_header">
            <el-row>
              <el-col :span="4">Nom resto</el-col>
              <el-col :span="2">Permanence</el-col>
              <el-col :span="2">Mail resto</el-col>
              <el-col :span="2">Sms client</el-col>
              <el-col :span="2">Sms rappel</el-col>
              <el-col :span="2">Caution/Pré.</el-col>
              <el-col :span="3"></el-col>
              <el-col :span="4"></el-col>
              <el-col :span="3"></el-col>
            </el-row>
          </el-col>
          <!-- values -->
          <el-col v-for="(resto, index) in getFilteredRestoInfos" :key="index" class="admin-resto-line">
            <el-row>
              <el-col :span="4">{{ resto.restoName }}</el-col>
              <el-col :span="2">
                <el-switch v-model="resto.permanenceOn" active-color="#00cec0" inactive-color="#e95d5d">
                </el-switch>
              </el-col>
              <el-col :span="2">
                <el-switch v-model="resto.restoMailSended" active-color="#00cec0" inactive-color="#e95d5d">
                </el-switch>
              </el-col>
              <el-col :span="2">
                <el-switch v-model="resto.clientSmsSended" active-color="#00cec0" inactive-color="#e95d5d">
                </el-switch>
              </el-col>
              <el-col :span="2">
                <el-switch v-model="resto.rappelSmsSended" active-color="#00cec0" inactive-color="#e95d5d">
                </el-switch>
              </el-col>
              <el-col :span="2">
                <el-switch v-model="resto.restoStripe" active-color="#00cec0" inactive-color="#e95d5d">
                </el-switch>
              </el-col>
              <el-col :span="3">
                <el-button type="primary"
                  @click="modifyRestoOption(index, resto.permanenceOn, resto.restoMailSended, resto.clientSmsSended, resto.rappelSmsSended, resto.restoStripe)">Valider</el-button>
              </el-col>
              <el-col :span="4">
                <el-button type="primary" @click="modifyPWD(index, resto.restoid)">Modifier PWD</el-button>
              </el-col>
              <el-col :span="3">
                <el-button type="danger" @click="deleteResto(index, resto.restoName)">Supprimer</el-button>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <!-- Stats Perm screen -->
    <el-row class="logapp" v-if="this.panelShow === 'StatsPerm'">
      <el-col :span="20" :offset="2" class="logapp-container2">
        <el-row class="dateChooser">
          <el-col :span="7" :offset="2">
            <el-date-picker class="datePicker" ref="picker" v-model="valueMinCalendar" format="dd/MM/yyyy" type="date"
              placeholder="Choisissez la date de départ" />
          </el-col>
          <el-col :span="7" :offset="2">
            <el-date-picker class="datePicker" ref="picker" v-model="valueMaxCalendar" format="dd/MM/yyyy" type="date"
              placeholder="Choisissez la date d'arrivé" />
          </el-col>
          <el-col :span="4" :offset="2">
            <el-button type="primary" @click="getStatsPermDatas()">Voir les stats</el-button>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-row class="logapp" v-if="this.panelShow === 'StatsPerm'">
      <el-col :span="20" :offset="2" class="logapp-container2">
        <el-row class="dateChooser" v-loading="statLoading">
          <div style="width:100%; text-align: center; margin:10px 0">
            <el-button v-if="getStatsTable.length > 0" @click="exportStats()">Télécharger les stats</el-button>
          </div>
          <el-table v-if="getStatsTable.length > 0" :default-sort="{ prop: 'total', order: 'descending' }"
            :data="getStatsTable" stripe style="width: 100%">
            <el-table-column prop="name" sortable label="Nom resto" width="220">
            </el-table-column>
            <el-table-column prop="email" sortable label="login" width="220">
            </el-table-column>
            <el-table-column prop="total" sortable label="Résas" width="70">
            </el-table-column>
            <el-table-column prop="nbSms" sortable label="Sms" width="70">
            </el-table-column>
            <!-- permanence -->
            <el-table-column label="Permanence" width="300">
              <el-table-column prop="permanenceTotal" sortable label="Total" width="100" />
              <el-table-column prop="permanenceNoShow" sortable label="NoShow" width="100" />
              <el-table-column prop="permanenceCancel" sortable label="Annul." width="100" />
            </el-table-column>
            <!-- resto -->
            <el-table-column label="Restaurant" width="300">
              <el-table-column prop="restoTotal" sortable label="Total" width="100" />
              <el-table-column prop="restoNoShow" sortable label="NoShow" width="100" />
              <el-table-column prop="restoCancel" sortable label="Annul." width="100" />
            </el-table-column>
            <!-- web -->
            <el-table-column label="Site web" width="300">
              <el-table-column prop="webTotal" sortable label="Total" width="100" />
              <el-table-column prop="webNoShow" sortable label="NoShow" width="100" />
              <el-table-column prop="webCancel" sortable label="Annul." width="100" />
            </el-table-column>
            <!-- google -->
            <el-table-column label="Google" width="300">
              <el-table-column prop="googleTotal" sortable label="Total" width="100" />
              <el-table-column prop="googleNoShow" sortable label="NoShow" width="100" />
              <el-table-column prop="googleCancel" sortable label="Annul." width="100" />
            </el-table-column>
            <!-- insta -->
            <el-table-column label="Instagram" width="300">
              <el-table-column prop="instagramTotal" sortable label="Total" width="100" />
              <el-table-column prop="instagramNoShow" sortable label="NoShow" width="100" />
              <el-table-column prop="instagramCancel" sortable label="Annul." width="100" />
            </el-table-column>
            <!-- facebook -->
            <el-table-column label="Facebook" width="300">
              <el-table-column prop="facebookTotal" sortable label="Total" width="100" />
              <el-table-column prop="facebookNoShow" sortable label="NoShow" width="100" />
              <el-table-column prop="facebookCancel" sortable label="Annul." width="100" />
            </el-table-column>
          </el-table>
          <el-col>
            Restaurants traité : {{ Object.entries(getStats).length }}
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <!-- app infos -->
    <el-row class="logapp" v-if="this.panelShow === 'AppInfos'">
      <el-col :span="20" :offset="2" class="logapp-container2">
        <el-button icon="el-icon-close" circle @click="showAdminContent('')"></el-button>
        <div class="logapp-panel">
          <h3>Infos de l'Application</h3>
          <el-form ref="formAppInfos" :model="formAppInfos" label-width="120px">
            <el-row v-loading="appInfosLoading">
              <el-col :md="9" :sm="20" :xs="20" :offset="2">
                <el-form-item prop="version" :rules="[
                  { required: true, message: 'Merci de rentrer une version', trigger: 'blur' }
                ]">
                  <el-input placeholder="version" v-model="formAppInfos.version" />
                </el-form-item>
              </el-col>
              <el-col :span="9" :offset="2">
                <el-col>
                  <span>Accès permanence test de l'ip : </span>
                  <el-switch v-model="formAppInfos.ipsCheck" active-color="#00cec0" inactive-color="#e95d5d">
                  </el-switch>
                </el-col>
              </el-col>
              <el-col :md="20" :sm="20" :xs="20" :offset="2" v-for="(ip, index) in formAppInfos.ips" :key="index">
                <el-form-item :rules="[
                  { required: true, message: 'Merci de rentrer une ip', trigger: 'blur' }
                ]">
                  <el-input placeholder="ip adresse : 192.168.0.1" v-model="formAppInfos.ips[index]" />
                </el-form-item>
              </el-col>
              <el-col :span="12" :offset="12">
                <el-form-item>
                  <el-button type="info" @click="formAppInfos.ips.push('')">Ajouter une ip</el-button>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item>
                  <el-button type="primary" @click="saveAppInfos()">Sauvegarder</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-col>
    </el-row>

    <!-- stripe -->
    <el-row class="logapp" v-if="this.panelShow === 'Stripe'">
      <el-col :span="20" :offset="2" class="logapp-container2">
        <el-row class="dateChooser">
          <el-col :span="7" :offset="2">
            <el-date-picker class="datePicker" ref="picker" v-model="valueMinCalendar" format="dd/MM/yyyy" type="date"
              placeholder="Choisissez la date de départ" />
          </el-col>
          <el-col :span="4" :offset="2">
            <el-button type="primary" @click="getStripeDatas()">Voir les stats</el-button>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-row class="logapp" v-if="this.panelShow === 'Stripe'">
      <el-col :span="20" :offset="2" class="logapp-container2">
        <el-row class="dateChooser" v-loading="stripeLoading">
          <div style="width:100%; text-align: center; margin:10px 0">
            <el-button v-if="getStripeTable.length > 0" @click="exportStatsStripe()">Télécharger les stats
              stripe</el-button>
          </div>
          <el-table v-if="getStripeTable.length > 0" :default-sort="{ prop: 'total', order: 'descending' }"
            :data="getStripeTable" stripe style="width: 100%">
            <el-table-column prop="name" sortable label="Nom resto" width="220">
            </el-table-column>
            <el-table-column prop="email" sortable label="login" width="220">
            </el-table-column>
            <!-- Caution -->
            <el-table-column label="Cautions" width="300">
              <el-table-column prop="nbResaCaution" sortable label="Nb" width="100" />
              <el-table-column prop="nbResaCautionPaid" sortable label="Nb Soldé" width="100" />
              <el-table-column prop="nbResaCautionUnPaid" sortable label="Nb Non Soldé" width="100" />
              <el-table-column prop="amountCautionUnPaid" sortable label="En attente" width="100" />
              <el-table-column prop="amountCautionPaid" sortable label="Facturé" width="100" />
            </el-table-column>
            <!-- Prépaiement -->
            <el-table-column label="Prépaiement" width="300">
              <el-table-column prop="nbResaPrepaiement" sortable label="Nb" width="100" />
              <el-table-column prop="nbResaPrepaiementPaid" sortable label="Nb Soldé" width="100" />
              <el-table-column prop="nbResaPrepaiementUnPaid" sortable label="Nb Non Soldé" width="100" />
              <el-table-column prop="amountPrepaiementUnPaid" sortable label="En attente" width="100" />
              <el-table-column prop="amountPrepaiementPaid" sortable label="Facturé" width="100" />
            </el-table-column>
            <!-- resto -->
            <el-table-column prop="total" sortable label="Total général facturé" width="220">
            </el-table-column>
          </el-table>
          <el-col>
            Restaurants traité : {{ Object.entries(getStripeTable).length }}
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <!-- Create new resto -->
    <el-row class="logapp" v-if="this.panelShow === 'SignUp'">
      <el-col :span="20" :offset="2" class="logapp-container2">
        <el-button icon="el-icon-close" circle @click="showAdminContent('')"></el-button>
        <div class="logapp-panel">
          <h3>Créer un compte</h3>
          <el-form ref="formSignUp" :rules="rulesForm" :model="formSignUp" label-width="120px">
            <el-row>
              <el-col :md="9" :sm="20" :xs="20" :offset="2">
                <el-form-item prop="email">
                  <el-input placeholder="'email > login'" v-model="formSignUp.email" />
                </el-form-item>
                <el-form-item prop="name">
                  <el-input placeholder="Nom" v-model="formSignUp.name" />
                </el-form-item>
                <el-form-item prop="secondname">
                  <el-input placeholder="Prénom" v-model="formSignUp.secondname" />
                </el-form-item>
                <el-form-item prop="adresse">
                  <el-input placeholder="Adresse" v-model="formSignUp.adresse" />
                </el-form-item>
                <el-form-item prop="adresse">
                  <el-input placeholder="Code postal" v-model="formSignUp.cpVille" />
                </el-form-item>
                <el-form-item prop="adresse">
                  <el-input placeholder="Ville" v-model="formSignUp.ville" />
                </el-form-item>
                <el-form-item>
                  <el-select v-model="formSignUp.langue" placeholder="Langue">
                    <el-option v-for="item in langueOptions" :key="item.value" :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select v-model="formSignUp.type" placeholder="Type">
                    <el-option v-for="item in restaurantType" :key="item.value" :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :md="9" :sm="20" :xs="20" :offset="2">
                <el-form-item prop="info">
                  <el-input placeholder="Nom du restaurant" v-model="formSignUp.restoName" />
                </el-form-item>
                <el-form-item prop="info">
                  <el-input placeholder="Forme juridique" v-model="formSignUp.formejuridique" />
                </el-form-item>
                <el-form-item prop="info">
                  <el-input placeholder="Dénomination" v-model="formSignUp.denomination" />
                </el-form-item>
                <el-form-item prop="info">
                  <el-input placeholder="SIRET" v-model="formSignUp.siret" />
                </el-form-item>
                <el-form-item prop="info">
                  <el-input placeholder="N° TVA" v-model="formSignUp.tva" />
                </el-form-item>
                <el-form-item prop="info">
                  <el-input placeholder="Site web" v-model="formSignUp.web" />
                </el-form-item>
                <el-form-item prop="codera">
                  <el-input placeholder="Code RA" v-model="formSignUp.codera" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item prop="password" style="width: 60%; margin: 0 auto 20px !important;">
              <el-input placeholder="Mot de passe" v-model="formSignUp.password" />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="signUp('formSignUp')">Créer</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-col>
    </el-row>

    <!-- Google info -->
    <el-row class="logapp" v-if="this.panelShow === 'Google'">
      <el-col :span="20" :offset="2" class="logapp-container2">
        <el-tabs tab-position="left">
          <el-tab-pane v-for="(resto, index) in restosInfos" :key="index" :label="resto.restoName">
            <h3>{{ resto.restoName }}</h3>
            <el-form ref="formGoogle" :rules="rulesForm" :model="resto" label-width="120px">
              <el-row>
                <el-col :span="12">
                  <el-form-item>
                    <el-input placeholder="Web" v-model="resto.restoWeb" />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item>
                    <el-input placeholder="Téléphone" v-model="resto.restoTelGoogle" />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item>
                    <el-input placeholder="Latitude" v-model="resto.restoLat" />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item>
                    <el-input placeholder="Longitude" v-model="resto.restoLong" />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item>
                    <el-input placeholder="Ville" v-model="resto.restoCity" />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item>
                    <el-input placeholder="Code postale" v-model="resto.restoPostalCode" />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item>
                    <el-input placeholder="Adresse" v-model="resto.restoAddress" />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item>
                    <el-input placeholder="Region" v-model="resto.restoRegion" />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item>
                    <el-input placeholder="Pays" v-model="resto.restoCountry" />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-form-item>
                <el-button type="primary" @click="updateGoogleInfos(resto)">Sauvegarder</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>

    <el-dialog title="Changement de mot de passe" :visible.sync="changePWD" width="50%">
      <el-form :model="formPWD" v-if="formPWD.canModifyPWD !== canModifyPWD">
        <el-form-item label="Déverouillez le formulaire de changement de mot de passe">
          <el-input v-model="formPWD.canModifyPWD"></el-input>
        </el-form-item>
      </el-form>
      <el-form ref="formPWDChange" :rules="rulesFormPWDChange" :model="formPWDChange"
        v-if="formPWD.canModifyPWD === canModifyPWD">
        <div style="margin-bottom: 10px">Pour :<br>{{ formPWDChange.email }}</div>
        <el-form-item label="Nouvel email" prop="newEmail" required>
          <el-input v-model="formPWDChange.newEmail"></el-input>
        </el-form-item>
        <el-form-item label="Nouveau mot de passe" prop="newPassword" required>
          <el-input v-model="formPWDChange.newPassword"></el-input>
        </el-form-item>
        <el-form-item label="Retaper le nouveau mot de passe" prop="newPasswordCheck" required>
          <el-input v-model="formPWDChange.newPasswordCheck"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="closeChangePWD()">Annuler</el-button>
          <el-button type="primary" :disabled="formPWD.canModifyPWD !== canModifyPWD"
            @click="submitFormPWD('formPWDChange')">Confirmer</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- Auth info -->
    <div class="admin-console" v-if="this.panelShow === 'Auth'">
      <vue-json-pretty :path="'res'" :deep="3" :data="getUser">
      </vue-json-pretty>
    </div>
  </div>
</div>
